<template>
    <div>
        <section-loader :loading="loading"/>

        <div v-if="packages">
            <div v-if="!isUpsell || upsellException">
                <div class="mb-5">
                    <hslp-package
                    v-if="!isAgent"
                        v-model="selectedPackagePlanName"
                        :is-upsell="isUpsell && !upsellException"
                        :legal-hours="legalHours(packages[1])"
                        :name="packages[1].planName"
                        :package="packages[1]"
                        :pay-at-close-price="pricePayAtClose(packages[1])"
                        :pay-now-price="pricePayNow(packages[1])"
                        :selected="packages[1].planName === selectedPackagePlanName"
                        :value="packages[1].planName"
                        :years-of-protection="yearsOfProtection(packages[1])"
                        class="mb-2"
                        @click="selectPackage(packages[1])"
                    />

                    <hslp-package
                        v-model="selectedPackagePlanName"
                        :is-upsell="isUpsell && !upsellException"
                        :legal-hours="legalHours(packages[2])"
                        :name="packages[2].planName"
                        :package="packages[2]"
                        :pay-at-close-price="pricePayAtClose(packages[2])"
                        :pay-now-price="pricePayNow(packages[2])"
                        :selected="packages[2].planName === selectedPackagePlanName"
                        :value="packages[2].planName"
                        :years-of-protection="yearsOfProtection(packages[2])"
                        class="mb-2"
                        most-popular
                        @click="selectPackage(packages[2])"
                    />

                    <hslp-package
                        v-model="selectedPackagePlanName"
                        :is-upsell="isUpsell && !upsellException"
                        :legal-hours="legalHours(packages[3])"
                        :name="packages[3].planName"
                        :package="packages[3]"
                        :pay-at-close-price="pricePayAtClose(packages[3])"
                        :pay-now-price="pricePayNow(packages[3])"
                        :selected="packages[3].planName === selectedPackagePlanName"
                        :value="packages[3].planName"
                        :years-of-protection="yearsOfProtection(packages[3])"
                        best-value
                        @click="selectPackage(packages[3])"
                    />
                </div>

                <div class="mb-5">
                    <div class="text-gray-dark font-size-4 font-weight-bold mb-4">
                        How would you like to pay?
                    </div>

                    <b-form-group class="px-2 mb-2">
                        <b-form-radio-group
                            v-model="selectedPaymentMethod"
                            name="payment-methods"
                        >
                            <b-form-radio
                                class="mb-2"
                                value="pay-now"
                            >
                                Pay {{ pricePayNow(selectedPackage) | currency('$', 0) }} now
                            </b-form-radio>

                            <b-form-radio
                                class="mb-2"
                                value="pay-at-close"
                            >
                                Pay {{ pricePayAtClose(selectedPackage) | currency('$', 0) }} at close out of commission
                                proceeds
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>


                <div class="mb-5">
                    <stripe-card
                        v-if="selectedPaymentMethod === 'pay-now'"
                        ref="stripeCard"
                        :amount="pricePayNow(selectedPackage)"
                        :email="buyerEmail"
                        :plan-name="selectedPackage.planName"
                    />
                    <div v-else-if="selectedPaymentMethod === 'pay-at-close'">
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-group>
                                    <label
                                        class="text-gray-dark font-size-4 font-weight-bold"
                                        for="closing-date"
                                    >
                                        Closing Date
                                    </label>

                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <span class="input-group-text-coherent">
                                                <i class="far fa-calendar-day font-size-3"/>
                                            </span>
                                        </b-input-group-prepend>

                                        <flat-pickr
                                            id="closing-date"
                                            v-model="closingDate"
                                            :config="closingDateConfig"
                                            class="form-control form-control-coherent"
                                        />
                                    </b-input-group>
                                    <p v-if="closingDateError" class="closing-date-error">
                                        {{ closingDateErrorMessage }}</p>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group>
                                    <label
                                        class="text-gray-dark font-size-4 font-weight-bold"
                                        for="title-company-name"
                                    >
                                        Title Company Name
                                    </label>

                                    <b-form-input
                                        id="title-company-name"
                                        v-model="titleCompanyName"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="6">
                                <b-form-group class="mb-0">
                                    <label
                                        class="text-gray-dark font-size-4 font-weight-bold"
                                        for="escrow-officer-name"
                                    >
                                        Escrow Officer Name
                                    </label>

                                    <b-form-input
                                        id="escrow-officer-name"
                                        v-model="escrowOfficerFullName"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group class="mb-0">
                                    <label
                                        class="text-gray-dark font-size-4 font-weight-bold"
                                        for="escrow-officer-email"
                                    >
                                        Escrow Officer Email
                                    </label>

                                    <b-form-input
                                        id="escrow-officer-email"
                                        v-model="escrowOfficerEmail"
                                    ></b-form-input>

                                    <b-form-invalid-feedback
                                        :state="isEmailValid"
                                        class="mt-2"
                                    >
                                        {{ errors.email }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </div>
                </div>

                <div>
                    <b-form-group>
                        <label
                            class="text-gray-dark font-size-4 font-weight-bold float-none"
                            for="additional-protected-sellers"
                        >
                            Additional protected sellers
                        </label>

                        <div class="text-gray-dark mb-4">
                            Please list the names of any additional legal owners below, separated by commas.
                        </div>

                        <b-form-textarea
                            id="additional-protected-sellers"
                            v-model="additionalLegalOwners"
                            class="overflow-auto"
                            placeholder="e.g. Richard Spier, Sharon Schafer-Spier"
                            rows="3"
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </div>

            <div v-else>
                <b-row class="mb-5">
                    <b-col
                        v-show="noProtection"
                        cols="12"
                        md="4"
                    >
                        <no-protection
                            v-model="selectedPackagePlanName"
                            :icon-src="require('@assets/images/empty_house.jpg')"
                            icon-alt="A nice-size house with a blue shield in front of it"
                            value="no-protection"
                            @click-no-protection-button="clickNoProtectionButton"
                        />
                    </b-col>

                    <b-col
                        :md="noProtection ? '4' : '6'"
                        cols="12"
                    >
                        <hslp-package
                            v-model="selectedPackagePlanName"
                            :icon-src="require('@assets/images/blue_house.jpg')"
                            :legal-hours="legalHours(packages[2])"
                            :name="packages[2].planName"
                            :package="packages[2]"
                            :pay-at-close-price="pricePayAtClose(packages[2])"
                            :pay-now-price="pricePayNow(packages[2])"
                            :selected="true"
                            :years-of-protection="yearsOfProtection(packages[2])"
                            icon-alt="A nice-size house with a blue shield in front of it"
                            is-upsell
                            most-popular
                            selected-payment-method="pay-now"
                            value="pay-now"
                            @select-payment-method="selectPaymentMethod"
                        />
                    </b-col>

                    <b-col
                        :md="noProtection ? '4' : '6'"
                        cols="12"
                    >
                        <hslp-package
                            v-model="selectedPackagePlanName"
                            :icon-src="require('@assets/images/blue_house.jpg')"
                            :legal-hours="legalHours(packages[2])"
                            :name="packages[2].planName"
                            :package="packages[2]"
                            :pay-at-close-price="pricePayAtClose(packages[2])"
                            :pay-now-price="pricePayNow(packages[2])"
                            :years-of-protection="yearsOfProtection(packages[2])"
                            icon-alt="A nice-size house with a blue shield in front of it"
                            is-upsell
                            selected-payment-method="pay-at-close"
                            value="pay-at-close"
                            @select-payment-method="selectPaymentMethod"
                        />
                    </b-col>
                </b-row>

                <div
                    v-if="selectedPaymentMethod === 'pay-now' && upsellPaymentVisible"
                    class="mb-5"
                >
                    <b-card>
                        <div class="h2 text-center mb-2">
                            Payment
                        </div>

                        <div class="font-size-4 text-center mb-4">
                            All transactions are secure and encrypted
                        </div>

                        <stripe-card
                            v-if="selectedPaymentMethod === 'pay-now'"
                            ref="stripeCard"
                            :amount="pricePayNow(selectedPackage)"
                            :email="buyerEmail"
                            :plan-name="selectedPackage.planName"
                            label="Credit card information:"
                        />
                    </b-card>
                </div>

                <div v-else-if="selectedPaymentMethod === 'pay-at-close' && upsellPaymentVisible">
                    <b-form-row>
                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group>
                                <label
                                    class="text-gray-dark font-size-4 font-weight-bold"
                                    for="closing-date"
                                >
                                    Closing Date
                                </label>

                                <b-input-group>
                                    <b-input-group-prepend>
                                            <span class="input-group-text-coherent">
                                                <i class="far fa-calendar-day font-size-3"/>
                                            </span>
                                    </b-input-group-prepend>

                                    <flat-pickr
                                        id="closing-date"
                                        v-model="closingDate"
                                        :config="closingDateConfig"
                                        class="form-control form-control-coherent"
                                    />
                                </b-input-group>
                                <p v-if="closingDateError" class="closing-date-error">{{ closingDateErrorMessage }}</p>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group>
                                <label
                                    class="text-gray-dark font-size-4 font-weight-bold"
                                    for="title-company-name"
                                >
                                    Title Company Name
                                </label>
                                <b-form-input
                                    id="title-company-name"
                                    v-model="titleCompanyName"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group class="mb-0">
                                <label
                                    class="text-gray-dark font-size-4 font-weight-bold"
                                    for="escrow-officer-name"
                                >
                                    Escrow Officer Name
                                </label>

                                <b-form-input
                                    id="escrow-officer-name"
                                    v-model="escrowOfficerFullName"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group class="mb-0">
                                <label
                                    class="text-gray-dark font-size-4 font-weight-bold"
                                    for="escrow-officer-email"
                                >
                                    Escrow Officer Email
                                </label>

                                <b-form-input
                                    id="escrow-officer-email"
                                    v-model="escrowOfficerEmail"
                                ></b-form-input>

                                <b-form-invalid-feedback
                                    :state="isEmailValid"
                                    class="mt-2"
                                >
                                    {{ errors.email }}
                                </b-form-invalid-feedback>

                            </b-form-group>


                        </b-col>
                    </b-form-row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs';
    import {cloneDeep} from 'lodash';
    import FlatPickr from 'vue-flatpickr-component';
    import FormErrorsMixin from '@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin';
    import {SST_HSLP} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderSolutionAppResource';
    import {
        AGENT,
        SELLER
    } from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuHslpUpsellPurchasedByTypeAppResource';
    import {
        PAY_AT_CLOSE,
        PAY_NOW
    } from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuHslpUpsellPaymentTermAppResource';
    import EscrowOfficerAppResource
        from '@sellers-shield-home-protection/ss-core-js/src/AppResources/EscrowOfficerAppResource';
    import HomeSaleLegalProtectionAppResource
        from '@sellers-shield-home-protection/ss-core-js/src/AppResources/HomeSaleLegalProtectionAppResource';
    import ZohoService from '@services/zoho.service';
    import UserMixin from '@mixins/UserMixin';
    import HslpMixin from '@mixins/HslpMixin';
    import HslpPackage from '../HslpPackage/HslpPackage';
    import StripeCard from '@components/other/StripeCard';
    import {
        invitationPropertyState,
        isProtected,
        notProtected,
        payAtClose,
        propertyState,
        discountAmount
    } from '@helpers/order';
    import {fetchEnabledStates} from '@helpers/state';
    import NoProtection from "../NoProtection/NoProtection";
    import {isValidEmail} from "@helpers/email";
    import {pageId} from "@helpers/fromPage";
    import {runAsPublic} from "@helpers/api-helper";
    import DiscountMixin from '@mixins/DiscountMixin';
    export default {
        name: 'HslpForm',
        mixins: [
            FormErrorsMixin,
            UserMixin,
            HslpMixin,
            DiscountMixin
        ],
        components: {
            FlatPickr,
            HslpPackage,
            StripeCard,
            NoProtection,
        },
        data: () => ({
            selectedPackage: null,
            selectedPaymentMethod: 'pay-now',
            isPayingAtClose: false,
            additionalLegalOwners: '',
            packages: null,
            closingDateConfig: {
                wrap: true,
                altFormat: 'M j, Y',
                dateFormat: 'Y-m-d',
            },
            closingDate: null,
            titleCompanyName: '',
            escrowOfficerFullName: '',
            escrowOfficerEmail: '',
            states: null,
            switchToggleColor: {
                checked: '#4F71C3',
                unchecked: '#4F71C3',
            },
            loading: false,
            errors: {
                email: '',
            },
            paymentIsInvalid: false,
        }),
        props: {
            orderAppResource: {
                type: Object,
            },
            sellerAppResource: {
                type: Object,
            },
            isUpsell: {
                type: Boolean,
            },
            upsellPaymentVisible: {
                type: Boolean,
            },
            noProtection: {
                type: Boolean,
                default: true,
            },
            isPublic: {
                type: Boolean,
            },
        },
        computed: {
            upsellException() {
                return (this.$route.name === 'order-details') && !this.isAgent;
            },
            propertyStateTitle() {
                return propertyState(this.orderAppResource)?.title || invitationPropertyState(this.orderAppResource, this.states)?.title;
            },
            propertyStateId(){
                return propertyState(this.orderAppResource)?.id || invitationPropertyState(this.orderAppResource, this.states)?.id;
            },
            isProtected() {
                return isProtected(this.orderAppResource);
            },
            payAtClose() {
                return payAtClose(this.orderAppResource);
            },
            notProtected() {
                return notProtected(this.orderAppResource);
            },
            escrowOfficerEmailInput() {
                return this.escrowOfficerEmail;
            },
            isEmailValid() {
                return this.errors.email.length === 0;
            },
            currentPageId() {
                return pageId(this.$route.name, this.isAgent);
            },
            buyerEmail() {
                if (this.isPublic && this.sellerAppResource) {
                    return this.sellerAppResource.email;
                }

                return this.me.email;
            },
            selectedPackagePlanName() {
                return this.selectedPackage?.planName;
            },

        },
        methods: {
            selectPaymentMethod(paymentMethod) {
                this.selectedPaymentMethod = paymentMethod;

                if (this.isUpsell && !this.upsellException) {
                    this.selectedPackage = Object.values(this.packages).find((value) => value.tier === "2");
                } else {
                    this.selectedPackage = Object.values(this.packages).find((value) => value.planName === paymentMethod);
                }
                this.$emit('change-payment-method', this.selectedPaymentMethod);
            },
            pricePayNow({pricePayNowAgent, pricePayNowSeller}) {
                return this.isAgent ? parseInt(pricePayNowAgent) : parseInt(pricePayNowSeller);
            },
            pricePayAtClose({pricePayAtCloseAgent, pricePayAtCloseSeller}) {
                return this.isAgent ? parseInt(pricePayAtCloseAgent) : parseInt(pricePayAtCloseSeller);
            },
            legalHours({legalHoursAgent, legalHoursSeller}) {
                return this.isAgent ? parseInt(legalHoursAgent) : parseInt(legalHoursSeller);
            },
            yearsOfProtection({yearsOfProtectionAgent, yearsOfProtectionSeller}) {
                return this.isAgent ? parseInt(yearsOfProtectionAgent) : parseInt(yearsOfProtectionSeller);
            },
            async fetchStates() {
                await runAsPublic(async () => {
                    const statesAppResourceCollection = await fetchEnabledStates();
                    this.states = statesAppResourceCollection.toArray();
                });
            },

            async getPricesByState() {
                return await ZohoService.getPricesByState(this.propertyStateId);
            },

            async updateOrder(orderAppResource) {
                if (this.isPublic) {
                    return await runAsPublic(async () => {
                        await orderAppResource.runUpdate();
                    });
                }

                return await orderAppResource.save();
            },

            async saveEscrowOfficerAppResource(escrowOfficerAppResource) {
                if (this.isPublic) {
                    return await runAsPublic(async () => {
                        await escrowOfficerAppResource.save();
                    });
                }

                return await escrowOfficerAppResource.save();
            },

            async saveHslpAppResource(hslpAppResource) {
                if (this.isPublic) {
                    return await runAsPublic(async () => {
                        await hslpAppResource.save();
                    });
                }

                return await hslpAppResource.save();
            },

            async fetchHslpPackages() {
                if (this.propertyStateTitle) {
                    console.log(this.propertyStateTitle);
                    this.packages = await this.getPricesByState();
                    Object.keys(this.packages).forEach(x => {
                        this.packages[x] = discountAmount(this.packages[x], this.discountAmount, this.vwoTesting, this.isSeller);
                    });
                    if (this.isUpsell && !this.upsellException) {
                        this.selectedPackage = Object.values(this.packages).find((value) => value.tier === '2');
                    } else {
                        this.selectedPackage = this.packages[2];
                    }
                }
            },
            async saveEscrowOfficer(orderAppResource) {
                let escrowOfficerAppResource = cloneDeep(orderAppResource.escrowOfficer) || new EscrowOfficerAppResource({});
                escrowOfficerAppResource.setAttribute('fullName', this.escrowOfficerFullName);
                escrowOfficerAppResource.setAttribute('email', this.escrowOfficerEmail);
                escrowOfficerAppResource.setAttribute('orderUuid',  orderAppResource.uuid);
                await this.saveEscrowOfficerAppResource(escrowOfficerAppResource);
            },
            async saveHslp(orderAppResource) {
                let hslpAppResource = orderAppResource.homeSaleLegalProtection ?
                    cloneDeep(orderAppResource.homeSaleLegalProtection) :
                    new HomeSaleLegalProtectionAppResource({attributes: {orderUuid: orderAppResource.uuid}});

                hslpAppResource.setAttribute('upsellPurchasedById', this.getPurchasedBy());
                hslpAppResource.setAttribute('upsellPaymentTermId', this.getPaymentTerm());

                if (this.selectedPaymentMethod === 'pay-now') {
                    hslpAppResource.setAttribute('upsellPrice', this.pricePayNow(this.selectedPackage));
                } else {
                    hslpAppResource.setAttribute('upsellPrice', this.pricePayAtClose(this.selectedPackage));
                }

                hslpAppResource.setAttribute('upsellPurchasedAt', dayjs(Date.now()));
                hslpAppResource.setAttribute('tier', this.selectedPackage.tier);
                hslpAppResource.setAttribute('legalProtectionAmount', this.legalHours(this.selectedPackage));
                hslpAppResource.setAttribute('yearsLegalProtection', this.yearsOfProtection(this.selectedPackage));
                hslpAppResource.setAttribute('paymentFromId', this.currentPageId);

                await this.saveHslpAppResource(hslpAppResource);
            },
            async addProtection(currentPageId) {

                if (!this.validateClosingDate()) {
                    return false;
                }

                let orderAppResource = cloneDeep(this.orderAppResource);

                if (this.selectedPaymentMethod === 'pay-now') {
                    let stripeResponse = await this.$refs.stripeCard.sendPayment(this.isPublic);
                    if (stripeResponse.data?.error) {
                        this.paymentIsInvalid = true;
                    }
                    /** needed for ss engine broken reactivity on attributes **/
                    this.orderAppResource.paymentReceivedAt = dayjs(Date.now());
                    orderAppResource.setAttribute('paymentReceivedAt', this.orderAppResource.paymentReceivedAt);

                } else {
                    await this.saveEscrowOfficer(orderAppResource);
                    /** needed for ss engine broken reactivity on attributes **/
                    this.orderAppResource.closingDate = this.closingDate;
                    this.orderAppResource.titleCompanyName = this.titleCompanyName;
                    orderAppResource.setAttribute('closingDate', this.orderAppResource.closingDate);
                    orderAppResource.setAttribute('titleCompanyName', this.orderAppResource.titleCompanyName);
                }

                if (!this.paymentIsInvalid) {

                    /** needed for ss engine broken reactivity on attributes **/
                    this.orderAppResource.solutionPurchasedId = this.getSolutionPurchased();
                    this.orderAppResource.orderedById = this.getPurchasedBy();
                    this.orderAppResource.paymentTermId = this.getPaymentTerm();
                    this.orderAppResource.additionalLegalOwners = this.additionalLegalOwners;

                    orderAppResource.setAttribute('solutionPurchasedId', this.orderAppResource.solutionPurchasedId );
                    orderAppResource.setAttribute('paymentTermId', this.orderAppResource.paymentTermId );
                    orderAppResource.setAttribute('orderedById', this.orderAppResource.orderedById);
                    orderAppResource.setAttribute('additionalLegalOwners', this.orderAppResource.additionalLegalOwners);

                    await this.updateOrder(orderAppResource);
                    await this.saveHslp(orderAppResource);
                    return orderAppResource;
                } else {
                    return null;
                }

            },
            selectPackage(selectedPackage) {
                this.selectedPackage = selectedPackage;
                this.selectedPackagePlanName = selectedPackage.planName;
            },
            getPaymentTerm() {
                return this.selectedPaymentMethod === 'pay-now' ? PAY_NOW : PAY_AT_CLOSE;
            },
            getPurchasedBy() {
                if (this.isPublic) {
                    return SELLER;
                }

                return this.isAgent ? AGENT : SELLER;
            },
            getSolutionPurchased() {
                return SST_HSLP;
            },
            validateEmail: function () {
                let email = this.escrowOfficerEmail;
                if (email.length === 0) {
                    return true;
                }
                this.validationEmail = isValidEmail(email);
                if (this.validationEmail) {
                    this.$set(this.errors, 'email', '');
                } else {
                    this.$set(this.errors, 'email', 'Invalid Email Address');
                }
            },
            clickNoProtectionButton() {
                this.$emit('click-no-protection');
            },
        },
        watch: {
            escrowOfficerEmailInput() {
                this.validateEmail();
            },
            discountCookieAmount:{
                immediate: true,
                async handler(){
                    await this.fetchHslpPackages();
                }
            }
        },

        async created() {
            await this.catchAppResourceErrors(async () => {
                await this.fetchStates();
            }, 'loading');
        },
        async mounted(){
            await this.catchAppResourceErrors(async () => {
                await this.fetchHslpPackages();
            }, 'loading');
        }

    }
</script>
